<template>
  <base-card>
    <div class="tw-flex tw-justify-between tw-items-center">
      <div class="tw-font-normal">Business Contacts</div>
      <base-button type="primary" @click="openCreateModal">
        Add Contact
        <template v-slot:icon>
          <plus-icon />
        </template>
      </base-button>
    </div>
    <base-list-group class="tw-mt-4">
      <base-list-item v-for="(contact, index) in contacts" :key="contact.businessContactId" :showBottomBorder="index != contacts.length - 1">
        <div class="tw-grid tw-grid-cols-3">
          <div class="tw-my-auto">{{ capitalize(contact.contactType) }}</div>
          <div class="tw-flex tw-flex-col tw-flex-grow">
            <div class="tw-text-sm">{{ contact.email }}</div>
            <base-phone-number-field class="tw-text-sm" :value="contact.phone" />
          </div>
          <div class="tw-flex tw-flex-shrink tw-gap-6 tw-my-auto tw-justify-end">
            <base-icon color="primary" @click="openEditModal(contact)"><edit-icon class="tw-w-4 tw-h-4"/></base-icon>
            <base-icon color="primary" @click="openDeleteModal(contact.businessContactId)"><trash-icon class="tw-w-4 tw-h-4"/></base-icon>
          </div>
        </div>
      </base-list-item>
    </base-list-group>
    <create-business-contact ref="createModal" :business-id="businessId" @created="loadContacts" />
    <edit-business-contact ref="editModal" :business-id="businessId" @edited="loadContacts" />
    <delete-business-contact ref="deleteModal" :business-id="businessId" @deleted="loadContacts" />
  </base-card>
</template>
<script>
import CreateBusinessContact from "@/views/business/profile/components/CreateBusinessContact";
import EditBusinessContact from "@/views/business/profile/components/EditBusinessContact";
import DeleteBusinessContact from "@/views/business/profile/components/DeleteBusinessContact";
import { PlusIcon, EditIcon, TrashIcon } from "@/assets/svgs";
import { capitalize } from "lodash";

export default {
  name: "BusinessContacts",
  components: {
    CreateBusinessContact,
    EditBusinessContact,
    DeleteBusinessContact,
    PlusIcon,
    EditIcon,
    TrashIcon,
  },
  props: {
    businessId: String,
    CreateBusinessContact,
    DeleteBusinessContact,
  },
  data() {
    return {
      contacts: {},
      isCreateLoading: false,
      isLoading: false,
      errors: null,
    };
  },
  created() {
    this.loadContacts();
  },
  computed: {},
  methods: {
    capitalize,
    openCreateModal() {
      this.$refs.createModal.show();
    },
    openEditModal(contact) {
      this.$refs.editModal.show(contact.businessContactId, contact.contactType, contact.email, contact.phone);
    },
    openDeleteModal(businessContactId) {
      this.$refs.deleteModal.show(businessContactId);
    },
    loadContacts() {
      this.isLoading = true;
      this.$axios
        .get(`/businesses/${this.businessId}/contacts`)
        .then((res) => {
          this.isLoading = false;
          this.contacts = res.data;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
          debugger;
        });
    },
  },
};
</script>
